import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import styles from "./DeniedTransaction.module.css";


import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { getTokenInfo } from "../../../utils/Guard";
import { UpdatePayment } from "../../../store/orden-store/orden-actions";


const DeniedTransaction = () => {
    
  let update = true;

   const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const navigate = useNavigate();

  const userInfo = getTokenInfo();
  const orden = useSelector((state) => state.orden.orden);
  const transacion = useSelector((state) => state.orden.transaction);
  const [amountDollar, setAmountDollar] = useState(0);
  const [amountRD, setAmountRD] = useState(0);
  const [count, setCount] = useState(0);


  const paymentInfo = {
    OrderNumber: searchParams.get("OrderNumber"),
    Amount: amountRD,
    AuthorizationCode: searchParams.get("AuthorizationCode"),
    DateTime: searchParams.get("DateTime"),
    ResponseCode: searchParams.get("ResponseCode"),
    IsoCode: searchParams.get("IsoCode"),
    ResponseMessage:
      searchParams.get("ResponseMessage") === "ERROR"
        ? "Declinada"
        : searchParams.get("ResponseMessage"),
    ErrorDescription: searchParams.get("ErrorDescription"),
    RRN: searchParams.get("RRN"),
    CustomOrderId: searchParams.get("OrderNumber"),
    CardNumber: searchParams.get("CardNumber").split("****")[1],
    AzulOrderId: searchParams.get("AzulOrderId"),
  };

  useEffect(() => {
    if (orden && orden.id !== undefined && orden.id > 0 && update) {
      update = false;
      dispatch(UpdatePayment(orden.id, userInfo.Email, paymentInfo));
    }
  }, [orden]);

    return (
        <div style={{marginTop:"11.5%", padding:"0% 10%", textAlign:"center"}}>
        <Card className={styles.cardMessage}>
        <div className={`pi pi-times-circle ${styles.checkCircleIcon}`}></div>
        
            <h1>Transacción denegada</h1>
            <p>Ha ocurrido un error en el pago </p>
            <p style={{color:"#1f3564", fontWeight:"600"}}>{paymentInfo.ResponseMessage}, Error {paymentInfo.IsoCode}</p>
            <p></p>
            
            <Button onClick={() => window.location.href = "/mycourses"} className={styles.button} label="Volver a mis cursos" />
        </Card>
        </div>
    );
    }

    export default DeniedTransaction;